import lodash from "lodash"

export const vaccinationApiRequestBody = (requestBody, profileDetails) => {
  let newRequestBody = {
    ...requestBody,
    "token": lodash.get(profileDetails, "auth_token"),
    "source_id": lodash.get(profileDetails, "source_id")
  };
  if (lodash.get(profileDetails, "source_id") === "emp_xp") {
    newRequestBody = {
      ...newRequestBody,
      "partner_id": "ril",
      "partner_user_info": {
        "id": lodash.get(profileDetails, "source_user_id"),
        "relation": lodash.get(profileDetails, "source_relation"),
        "relation_id": lodash.get(profileDetails, "source_user_relation_id")
      }
    }
  }

  if (lodash.get(profileDetails, "source_id") === "jiohealthhub") {
    newRequestBody = {
      ...newRequestBody,
      "jhh_id": lodash.get(profileDetails, "jhh_id"),
    }
  }
  return newRequestBody;
}